var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M3.532 4a.854.854 0 00-.854.992L6.305 27.03a1.163 1.163 0 001.136.97h17.4a.854.854 0 00.855-.717l3.627-22.286a.855.855 0 00-.855-.991L3.532 4zm15.273 15.927H13.25l-1.503-7.863h8.403l-1.346 7.863z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }